/**
 * Admin de Talent Acquisition (Sol 28/09/2026): reemplaza la tab "Permisos" y
 * concentra TODA la administración de la sección en subtabs propias (mismo
 * patrón que /owned-media/admin: Tabs + query param):
 *  - Permisos: quién administra y quién ve la sección (GovernancePanel).
 *  - Hiring managers: quién puede abrir una búsqueda.
 *  - Bot: los system prompts de los dos agentes, editables con "restaurar".
 *  - Reglas de cálculo y Fotos semanales: lo que ya estaba.
 */
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TaGovernanceTab } from './TaGovernanceTab';
import { TaHiringManagersCard } from './TaHiringManagersCard';
import { TaAgentPromptsCard } from './TaAgentPromptsCard';
import { TaRulesCard } from './TaRulesCard';
import { TaSnapshotsCard } from './TaSnapshotsCard';

const SECTIONS = ['permisos', 'hiring', 'bot', 'reglas', 'fotos'] as const;
type Section = (typeof SECTIONS)[number];

export function TaAdminTab() {
  const { t } = useTranslation();
  const k = 'talent_acquisition.admin';
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('admin');
  const section: Section = (SECTIONS as readonly string[]).includes(raw ?? '') ? (raw as Section) : 'permisos';
  const setSection = (next: string) => {
    const params = new URLSearchParams(searchParams);
    params.set('admin', next);
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">{t(`${k}.subtitle`)}</p>
      <Tabs value={section} onValueChange={setSection}>
        <TabsList className="flex h-auto flex-wrap">
          {SECTIONS.map((s) => <TabsTrigger key={s} value={s}>{t(`${k}.section_${s}`)}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="permisos" className="mt-4"><TaGovernanceTab /></TabsContent>
        <TabsContent value="hiring" className="mt-4"><TaHiringManagersCard /></TabsContent>
        <TabsContent value="bot" className="mt-4"><TaAgentPromptsCard /></TabsContent>
        <TabsContent value="reglas" className="mt-4"><TaRulesCard /></TabsContent>
        <TabsContent value="fotos" className="mt-4"><TaSnapshotsCard /></TabsContent>
      </Tabs>
    </div>
  );
}
